var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "a",
    {
      attrs: {
        href: _vm.url,
        title: _vm.$gettextInterpolate(
          _vm.$gettext("Unterebene %{ node } öffnen"),
          {
            node: _vm.node.attributes.name,
          },
          true
        ),
      },
      on: {
        click: function click($event) {
          $event.preventDefault()
          return _vm.openNode.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "p",
        {
          staticClass: "studip-tree-child-title",
        },
        [_vm._v("\n        " + _vm._s(_vm.node.attributes.name) + "\n    ")]
      ),
      _vm._v(" "),
      _vm.node.attributes.ancestors.length > 2
        ? _c("tree-node-course-info", {
            attrs: {
              node: _vm.node,
              semester: _vm.semester,
              "sem-class": _vm.semClass,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }